export default __webpack_public_path__ + "static/media/13 (1).d0de85c9.jpg";